<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- ===== HERO ===== -->
  <section class="relative min-h-[60vh] flex items-center pt-24 pb-16 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <app-navigate-back class="mb-4"></app-navigate-back>
      <h1 class="text-5xl md:text-6xl font-black mb-6" data-aos="fade-up" data-aos-delay="100">
        Everything You Need <span class="text-varroc-accent">to Know & Grow</span>
      </h1>
      <p class="text-varroc-text-gray text-xl max-w-3xl" data-aos="fade-up" data-aos-delay="200">
        Insights, documentation, case studies, and support all in one place.
      </p>
    </div>
  </section>

  <!-- ===== STICKY NAV ===== -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">

    <!-- ===== CASE STUDIES =====
    <section id="casestudies" class="section-anchor">
      <div class="flex items-end justify-between mb-10" data-aos="fade-up">
        <div>
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Case Studies</span>
          <h2 class="text-4xl font-black mt-2">Real Results, Real Customers</h2>
        </div>
      </div>
      <div class="grid md:grid-cols-2 gap-8">
        <div *ngFor="let cs of caseStudies; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
          <div class="flex items-center justify-between mb-4">
            <span class="bg-varroc-accent/20 text-varroc-accent text-xs font-bold px-3 py-1 rounded-full">{{ cs.industry }}</span>
          </div>
          <h3 class="text-white font-bold text-lg mb-1">{{ cs.company }}</h3>
          <p class="text-varroc-accent font-semibold text-sm mb-3">{{ cs.outcome }}</p>
          <p class="text-varroc-text-gray text-sm leading-relaxed mb-6">{{ cs.detail }}</p>
          <div class="grid grid-cols-3 gap-3 pt-4 border-t border-varroc-border">
            <div *ngFor="let m of cs.metrics" class="text-center">
              <div class="text-varroc-accent font-black text-xl">{{ m.val }}</div>
              <div class="text-varroc-text-gray text-xs mt-0.5">{{ m.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>
    -->

    <!-- ===== DOCS ===== -->
    <section id="docs" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Product Docs</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Developer Documentation</h2>
        <p class="text-varroc-text-gray text-lg max-w-xl mx-auto">Everything you need to integrate, deploy, and operate Varroc Connect products.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <div *ngFor="let doc of docs; let i = index" class="feature-card group cursor-pointer" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
          <div class="flex items-start justify-between mb-4">
            <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center">
              <i class='bx icon-gradient text-xl' [class]="doc.icon"></i>
            </div>
            <span class="text-xs text-varroc-text-gray border border-varroc-border px-2 py-0.5 rounded-full">{{ doc.tag }}</span>
          </div>
          <h3 class="text-white font-bold mb-2 group-hover:text-varroc-accent transition-colors">{{ doc.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ doc.desc }}</p>
        </div>
      </div>
      <div class="text-center mt-8" data-aos="fade-up">
        <a routerLink="/contact-us" class="inline-block bg-varroc-accent text-white font-bold px-8 py-3 rounded-md hover:bg-varroc-accent-hover transition-all developer_documentation_request_documentation_access_button">
          Request Documentation Access
        </a>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== MEDIA ===== -->
    <section id="media" class="section-anchor">
      <div class="grid md:grid-cols-[1fr_auto] items-center gap-8 feature-card" data-aos="fade-up">
        <div>
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Media</span>
          <h2 class="text-4xl font-black mt-2 mb-4">News, Interviews & Creative Assets</h2>
          <p class="text-varroc-text-gray text-lg max-w-3xl">Explore Varroc Connect product creatives and browse our media resources in one place.</p>
        </div>
        <a routerLink="/media" class="inline-flex items-center justify-center gap-2 bg-varroc-accent text-white font-bold px-7 py-3 rounded-md hover:bg-varroc-accent-hover transition-all whitespace-nowrap">
          Explore Media Gallery <i class='bx bx-right-arrow-alt text-xl' aria-hidden="true"></i>
        </a>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== BLOGS ===== -->
    <section id="blogs" class="section-anchor">
      <div class="flex items-end justify-between mb-10" data-aos="fade-up">
        <div>
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Blogs</span>
          <h2 class="text-4xl font-black mt-2">Insights & Stories</h2>
        </div>
        <a (click)="viewAllPosts()" style="cursor:pointer"
          class="inline-flex items-center gap-2 text-varroc-accent text-sm font-semibold hover:underline" data-aos="fade-left">
          <i class='bx bx-rss'></i> View All Posts
        </a>
      </div>

      <!-- Loading skeleton -->
      <div *ngIf="blogLoading" class="grid md:grid-cols-3 gap-8">
        <div *ngFor="let _ of [1,2,3,4]" class="feature-card p-0 overflow-hidden animate-pulse">
          <div class="aspect-video bg-varroc-border"></div>
          <div class="p-6 space-y-3">
            <div class="h-3 bg-varroc-border rounded w-1/4"></div>
            <div class="h-5 bg-varroc-border rounded w-full"></div>
            <div class="h-5 bg-varroc-border rounded w-3/4"></div>
            <div class="h-3 bg-varroc-border rounded w-2/5"></div>
          </div>
        </div>
      </div>

      <!-- Blog cards -->
      <div *ngIf="!blogLoading">
        <ng-container *ngIf="blogPosts.length > 0; else noBlogsSection">
          <div class="grid md:grid-cols-3 gap-8">
            <div *ngFor="let post of blogPosts; let i = index"
              (click)="openBlog(post)"
              class="feature-card p-0 overflow-hidden group hover:border-varroc-accent transition-all duration-300 block cursor-pointer"
              [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
              <div class="relative overflow-hidden aspect-video">
                <img *ngIf="post.coverImage" [src]="post.coverImage" [alt]="post.seo.imageAltTags[0] || post.title"
                  class="absolute inset-0 w-full h-full object-contain bg-varroc-darker group-hover:scale-105 transition-transform duration-500">
                <div *ngIf="!post.coverImage" class="absolute inset-0 bg-varroc-darker flex items-center justify-center">
                  <i class='bx bx-news text-5xl text-varroc-border'></i>
                </div>
              </div>
              <div class="p-6">
                <span *ngIf="post.category" class="text-varroc-accent text-xs font-bold uppercase tracking-widest mb-2 block">{{ post.category }}</span>
                <h3 class="text-white font-bold text-lg mb-2 group-hover:text-varroc-accent transition-colors leading-snug line-clamp-2">{{ post.title }}</h3>
                <p class="text-varroc-text-gray text-sm leading-relaxed mb-4 line-clamp-2">{{ post.excerpt }}</p>
                <div class="flex items-center justify-between pt-4 border-t border-varroc-border">
                  <div class="flex items-center gap-2">
                    <i class='bx bx-user-circle text-varroc-text-gray text-base'></i>
                    <span class="text-varroc-text-gray text-xs">{{ post.author.name }}</span>
                  </div>
                  <span class="text-varroc-text-gray text-xs">{{ post.publishedDate | date: 'MMM d, yyyy' }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noBlogsSection>
          <div class="feature-card p-10 text-center">
            <i class='bx bx-error-circle icon-gradient text-4xl mb-3'></i>
            <p class="text-varroc-text-gray mb-3">Couldn't load blog posts right now.</p>
            <a (click)="viewAllPosts()" style="cursor:pointer"
              class="text-varroc-accent font-semibold hover:underline">Visit our Blog →</a>
          </div>
        </ng-template>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== FAQS & SUPPORT ===== -->
    <section id="support" class="section-anchor">
      <div>
        <div class="w-full">
          <div class="mb-10" data-aos="fade-up">
            <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">FAQs</span>
            <h2 class="text-4xl font-black mt-2">Frequently Asked Questions</h2>
          </div>
          <div class="space-y-4">
            <div *ngFor="let faq of faqs; let i = index" class="border border-varroc-border rounded-xl overflow-hidden transition-all" data-aos="fade-up" [attr.data-aos-delay]="(i * 60).toString()">
              <button (click)="toggleFaq(i)" class="w-full flex items-center justify-between p-5 text-left hover:bg-varroc-dark/50 transition-colors">
                <span class="text-white font-semibold text-sm pr-4">{{ faq.q }}</span>
                <i class='bx icon-gradient text-xl flex-shrink-0 transition-transform duration-300' [class]="faq.open ? 'bx-minus' : 'bx-plus'"></i>
              </button>
              <div *ngIf="faq.open" class="px-5 pb-5 text-varroc-text-gray text-sm leading-relaxed border-t border-varroc-border pt-4">
                {{ faq.a }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</main>
